module.exports = __webpack_public_path__ + "img/smart-card-icon.8a5cf2c9.svg";